// src/student/components/StudentProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useStudentAuth } from "../context/StudentAuthContext";

const StudentProtectedRoute = ({ children }) => {
  const { isStudentAuthenticated } = useStudentAuth();
  const location = useLocation();

  if (!isStudentAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default StudentProtectedRoute;
